<script>
import { sortByDistance } from "sort-by-distance";

export default {
  render() {
    return this.$scopedSlots.default({
      sortedLocations: this.sortedLocations,
      isSorted: this.isSorted,
    });
  },
  mounted() {
    this.getGeo();
  },
  props: {
    params: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sortedLocations: null,
      coords: null,
      hasError: false,
    };
  },
  watch: {
    params: {
      handler(value, oldValue) {
        if (!oldValue) return;
        if (value.length !== oldValue.length) {
          if (!this.hasError) this.sortByDistance(this.coords);
          this.sortedLocations = value;
        }
      },
    },
  },
  computed: {
    geolocation() {
      return navigator.geolocation;
    },
  },
  methods: {
    getGeo() {
      if ("geolocation" in navigator) {
        this.getCurrentPosition(navigator);
      } else {
        console.warn("Geolocation is not supported by your browser");
        this.sortedLocations = this.params;
      }
    },
    getCurrentPosition(nav) {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      nav?.geolocation?.getCurrentPosition(this.success, this.error, options);
    },
    success(pos) {
      this.coords = pos?.coords;
      this.sortByDistance(this.coords);
    },
    error(error) {
      this.sortedLocations = this.params;
      this.hasError = true;
      console.error(`ERROR(${error.code}): ${error.message}`);
    },
    sortByDistance(coords) {
      if (!coords) return;

      const options = {
        yName: "latitude",
        xName: "longitude",
      };

      const origin = {
        latitude: coords.latitude,
        longitude: coords.longitude,
      };

      const sortedLocations = sortByDistance(origin, this.params, options);

      this.mapSortedDistance(sortedLocations);
    },
    mapSortedDistance(sortedLocations) {
      this.sortedLocations = sortedLocations.map((el) => {
        return {
          ...el,
          formmatted_distance: `(${el?.distance?.toFixed(2)} mi away)`,
        };
      });
    },
  },
};
</script>
